import React from "react";
import heroImage from '@/images/hero/hero_1920.jpg';
import hero4k from '@/images/hero/hero_4000.jpg';
import hero640 from '@/images/hero/hero_640.jpg';
import hero768 from '@/images/hero/hero_768.jpg';
import hero1024 from '@/images/hero/hero_1024.jpg';
import hero1280 from '@/images/hero/hero_1280.jpg';
import hero1536 from '@/images/hero/hero_1536.jpg';


class Hero extends React.Component {

  render() { 
    let srcSet = `${heroImage} 1920w, ${hero4k} 3993w, ${hero640} 640w, ${hero768} 768w, ${hero1024} 1024w, ${hero1280} 1280w, ${hero1536} 1536w`
    return <div className="z-0">
      <img src={heroImage} srcSet={srcSet} sizes="100vw" alt="" className="z-0" />
      <div className="hidden md:flex absolute 2xl:top-1/3 md:bottom-2/3 bottom-3/4 transform -translate-y-1/2 lg:translate-y-0 justify-center w-full">
        <p className="w-3/4 xl:text-5xl lg:text-4xl md:text-3xl leading-tight font-t-semibold z-10">
          Trouver sa voie <br/>
          avec l'uB,<br/>
          c'est facile !</p>
      </div>
    </div>;
  }

}
export default Hero;